var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEquipment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1549_41372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8V0H0V14H52V8H6ZM50 10H4V2H2V12H50V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 51.998V13.998H6V51.998H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.002 52V47H40.002V52H38.002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.999 52V8H17.999V52H15.999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 52V13.5H52V52H50Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.999 48H4.99902V46H50.999V48Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 26H17V24H51V26Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 32H22V30H46V32Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.999 2H4.99902V0H38.999V8H36.999V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.999 19.998C34.5513 19.998 34.999 19.5503 34.999 18.998C34.999 18.4457 34.5513 17.998 33.999 17.998C33.4467 17.998 32.999 18.4457 32.999 18.998C32.999 19.5503 33.4467 19.998 33.999 19.998ZM33.999 21.998C35.6559 21.998 36.999 20.6549 36.999 18.998C36.999 17.3411 35.6559 15.998 33.999 15.998C32.3421 15.998 30.999 17.3411 30.999 18.998C30.999 20.6549 32.3421 21.998 33.999 21.998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.001 19.998C24.5533 19.998 25.001 19.5503 25.001 18.998C25.001 18.4457 24.5533 17.998 24.001 17.998C23.4487 17.998 23.001 18.4457 23.001 18.998C23.001 19.5503 23.4487 19.998 24.001 19.998ZM24.001 21.998C25.6579 21.998 27.001 20.6549 27.001 18.998C27.001 17.3411 25.6579 15.998 24.001 15.998C22.3441 15.998 21.001 17.3411 21.001 18.998C21.001 20.6549 22.3441 21.998 24.001 21.998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 19.998C44.5523 19.998 45 19.5503 45 18.998C45 18.4457 44.5523 17.998 44 17.998C43.4477 17.998 43 18.4457 43 18.998C43 19.5503 43.4477 19.998 44 19.998ZM44 21.998C45.6569 21.998 47 20.6549 47 18.998C47 17.3411 45.6569 15.998 44 15.998C42.3431 15.998 41 17.3411 41 18.998C41 20.6549 42.3431 21.998 44 21.998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1549_41372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEquipment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/equipment.986a033611bb41679c13aca1573435db.svg";